import _typeof from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/typeof";
import _objectSpread from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@iterator",
    c = i.asyncIterator || "@asyncIterator",
    u = i.toStringTag || "@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
} /*@通用-数据层*/
import { create_agency as _create_agency, create_company_contract as _create_company_contract, create_company_related_person as _create_company_related_person, create_iptable as _create_iptable, create_topo, delete_agency as _delete_agency, delete_agency_batch as _delete_agency_batch, delete_attachment as _delete_attachment, delete_iptable as _delete_iptable, delete_topo as _delete_topo, delete_topo_batch as _delete_topo_batch, get_agency_list, get_company_list, get_company_related_person, get_contract_list, get_iptable_list, get_related_person_list, get_topo_list, update_company, update_contract as _update_contract, updateRelatedPerson } from "../../services/Company/companyS";
import { BossMessage } from "../../components/Common/BossMessages";
export default {
  namespace: "bi0102Info",
  state: {
    companyInfo: {},
    outerBusiness: {},
    business: {},
    outerTech: {},
    tech: {},
    cStepData: [],
    stepData: [],
    topoData: [],
    contractData: [],
    relatedPersonList: [],
    optionData: [],
    optionData2: [],
    ifEditCompany: false,
    ipTableList: [],
    file_list: []
  },
  effects: {
    init: function init(_ref, _ref2) {
      var payload = _ref.payload;
      var call = _ref2.call,
        put = _ref2.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var backData, backData1, cStepData, stepData, topoData, contractData, relatedPersonList;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return call(get_company_list, payload);
            case 2:
              backData = _context.sent;
              _context.next = 5;
              return call(get_company_related_person, payload);
            case 5:
              backData1 = _context.sent;
              _context.next = 8;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "CSTEP"
              });
            case 8:
              cStepData = _context.sent;
              _context.next = 11;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "STEP"
              });
            case 11:
              stepData = _context.sent;
              _context.next = 14;
              return call(get_topo_list, {
                company_id: payload.company_id
              });
            case 14:
              topoData = _context.sent;
              _context.next = 17;
              return call(get_contract_list, {
                company_id: payload.company_id
              });
            case 17:
              contractData = _context.sent;
              _context.next = 20;
              return call(get_related_person_list, {
                company_id: 1
              });
            case 20:
              relatedPersonList = _context.sent;
              _context.next = 23;
              return put({
                type: "update",
                payload: {
                  companyInfo: backData.result[0],
                  outerBusiness: backData1.outer_business,
                  business: backData1.business,
                  outerTech: backData1.outer_technology,
                  tech: backData1.technology,
                  cStepData: cStepData.result,
                  stepData: stepData.result,
                  topoData: topoData.result,
                  contractData: contractData.result,
                  relatedPersonList: relatedPersonList.result
                }
              });
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })();
    },
    editCompany: function editCompany(_ref3, _ref4) {
      var payload = _ref3.payload;
      var put = _ref4.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return put({
                type: "update",
                payload: {
                  ifEditCompany: payload.ifEditCompany
                }
              });
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })();
    },
    updateContactData: function updateContactData(_ref5, _ref6) {
      var payload = _ref5.payload;
      var call = _ref6.call,
        put = _ref6.put,
        select = _ref6.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var outerBusiness, outerTech;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return select(function (state) {
                return state.bi0102Info.outerBusiness;
              });
            case 2:
              outerBusiness = _context3.sent;
              _context3.next = 5;
              return select(function (state) {
                return state.bi0102Info.outerTech;
              });
            case 5:
              outerTech = _context3.sent;
              outerBusiness.name = payload.values.outerBusinessName;
              outerBusiness.tel = payload.values.outerBusinessTel;
              outerBusiness.address = payload.values.outerBusinessAddress;
              outerBusiness.remark = payload.values.outerBusinessRemark;
              outerTech.name = payload.values.outerTechName;
              outerTech.tel = payload.values.outerTechTel;
              outerTech.address = payload.values.outerTechAddress;
              outerTech.remark = payload.values.outerTechRemark;
              _context3.next = 16;
              return put({
                type: "update",
                payload: {
                  outerBusiness: outerBusiness,
                  outerTech: outerTech
                }
              });
            case 16:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      })();
    },
    updateTechData: function updateTechData(_ref7, _ref8) {
      var payload = _ref7.payload;
      var call = _ref8.call,
        put = _ref8.put,
        select = _ref8.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var tech;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return select(function (state) {
                return state.bi0102Info.tech;
              });
            case 2:
              tech = _context4.sent;
              tech.id = payload.id;
              _context4.next = 6;
              return put({
                type: "update",
                payload: {
                  tech: tech
                }
              });
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      })();
    },
    submitContactData: function submitContactData(_ref9, _ref10) {
      var payload = _ref9.payload;
      var call = _ref10.call,
        put = _ref10.put,
        select = _ref10.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var result1, result2, result3;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return call(updateRelatedPerson, payload.outerTech);
            case 2:
              result1 = _context5.sent;
              _context5.next = 5;
              return call(updateRelatedPerson, payload.outerBusiness);
            case 5:
              result2 = _context5.sent;
              _context5.next = 8;
              return call(update_company, payload.company);
            case 8:
              result3 = _context5.sent;
              if (result1.success && result2.success && result3.success) {
                BossMessage(true, "Successfully edited");
              } else {
                if (!result1.success) {
                  BossMessage(false, "Editing failed:" + result1.result);
                } else if (!result2.success) {
                  BossMessage(false, "Editing failed:" + result2.result);
                } else if (!result3.success) {
                  BossMessage(false, "Editing failed:" + result3.result);
                }
              }
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })();
    },
    create_company_related_person: function create_company_related_person(_ref11, _ref12) {
      var payload = _ref11.payload;
      var call = _ref12.call,
        put = _ref12.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return call(_create_company_related_person, payload);
            case 2:
              backData = _context6.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      })();
    },
    updateCompanyData: function updateCompanyData(_ref13, _ref14) {
      var payload = _ref13.payload;
      var call = _ref14.call,
        put = _ref14.put,
        select = _ref14.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var companyInfo;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return select(function (state) {
                return state.bi0102Info.companyInfo;
              });
            case 2:
              companyInfo = _context7.sent;
              companyInfo.company = payload.values.company;
              companyInfo.company_tax = payload.values.company_tax;
              companyInfo.trade = payload.values.trade;
              companyInfo.status = payload.values.status;
              _context7.next = 9;
              return put({
                type: "update",
                payload: {
                  companyInfo: companyInfo
                }
              });
            case 9:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      })();
    },
    submitEditCompany: function submitEditCompany(_ref15, _ref16) {
      var payload = _ref15.payload;
      var call = _ref16.call,
        put = _ref16.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var result;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return call(update_company, payload);
            case 2:
              result = _context8.sent;
              if (!result.success) {
                _context8.next = 7;
                break;
              }
              BossMessage(true, "Successfully edited");
              _context8.next = 7;
              return put({
                type: "update",
                payload: {
                  ifEditCompany: false
                }
              });
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      })();
    },
    create_agency: function create_agency(_ref17, _ref18) {
      var payload = _ref17.payload;
      var call = _ref18.call,
        put = _ref18.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var backData, cStepData, stepData;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return call(_create_agency, payload);
            case 2:
              backData = _context9.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
              if (!(payload.type === "CSTEP")) {
                _context9.next = 12;
                break;
              }
              _context9.next = 7;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "CSTEP"
              });
            case 7:
              cStepData = _context9.sent;
              _context9.next = 10;
              return put({
                type: "update",
                payload: {
                  cStepData: cStepData.result
                }
              });
            case 10:
              _context9.next = 18;
              break;
            case 12:
              if (!(payload.type === "STEP")) {
                _context9.next = 18;
                break;
              }
              _context9.next = 15;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "STEP"
              });
            case 15:
              stepData = _context9.sent;
              _context9.next = 18;
              return put({
                type: "update",
                payload: {
                  stepData: stepData.result
                }
              });
            case 18:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      })();
    },
    getAddLinkFormOption: function getAddLinkFormOption(_ref19, _ref20) {
      var payload = _ref19.payload;
      var call = _ref20.call,
        put = _ref20.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var optionData;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "CSTEP,STEP"
              });
            case 2:
              optionData = _context10.sent;
              _context10.next = 5;
              return put({
                type: "update",
                payload: {
                  optionData: optionData.result,
                  optionData2: optionData.result
                }
              });
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })();
    },
    createTopo: function createTopo(_ref21, _ref22) {
      var payload = _ref21.payload;
      var call = _ref22.call,
        put = _ref22.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var backData, topoData;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return call(create_topo, payload);
            case 2:
              backData = _context11.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
              _context11.next = 6;
              return call(get_topo_list, {
                company_id: payload.company_id
              });
            case 6:
              topoData = _context11.sent;
              _context11.next = 9;
              return put({
                type: "update",
                payload: {
                  topoData: topoData.result
                }
              });
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      })();
    },
    delete_agency_batch: function delete_agency_batch(_ref23, _ref24) {
      var payload = _ref23.payload;
      var call = _ref24.call,
        put = _ref24.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var backData, cStepData, stepData;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return call(_delete_agency_batch, payload);
            case 2:
              backData = _context12.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              if (!(payload.type === "CSTEP")) {
                _context12.next = 12;
                break;
              }
              _context12.next = 7;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "CSTEP"
              });
            case 7:
              cStepData = _context12.sent;
              _context12.next = 10;
              return put({
                type: "update",
                payload: {
                  cStepData: cStepData.result
                }
              });
            case 10:
              _context12.next = 18;
              break;
            case 12:
              if (!(payload.type === "STEP")) {
                _context12.next = 18;
                break;
              }
              _context12.next = 15;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "STEP"
              });
            case 15:
              stepData = _context12.sent;
              _context12.next = 18;
              return put({
                type: "update",
                payload: {
                  stepData: stepData.result
                }
              });
            case 18:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      })();
    },
    delete_agency: function delete_agency(_ref25, _ref26) {
      var payload = _ref25.payload;
      var call = _ref26.call,
        put = _ref26.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var backData, cStepData, stepData;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return call(_delete_agency, payload);
            case 2:
              backData = _context13.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              if (!(payload.type === "CSTEP")) {
                _context13.next = 12;
                break;
              }
              _context13.next = 7;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "CSTEP"
              });
            case 7:
              cStepData = _context13.sent;
              _context13.next = 10;
              return put({
                type: "update",
                payload: {
                  cStepData: cStepData.result
                }
              });
            case 10:
              _context13.next = 18;
              break;
            case 12:
              if (!(payload.type === "STEP")) {
                _context13.next = 18;
                break;
              }
              _context13.next = 15;
              return call(get_agency_list, {
                company_id: payload.company_id,
                type: "STEP"
              });
            case 15:
              stepData = _context13.sent;
              _context13.next = 18;
              return put({
                type: "update",
                payload: {
                  stepData: stepData.result
                }
              });
            case 18:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      })();
    },
    LinkTableInit: function LinkTableInit(_ref27, _ref28) {
      var payload = _ref27.payload;
      var call = _ref28.call,
        put = _ref28.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var backData;
        return _regeneratorRuntime().wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return call(get_iptable_list, payload);
            case 2:
              backData = _context14.sent;
              _context14.next = 5;
              return put({
                type: "update",
                payload: {
                  ipTableList: backData.result
                }
              });
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee14);
      })();
    },
    delete_iptable: function delete_iptable(_ref29, _ref30) {
      var payload = _ref29.payload;
      var call = _ref30.call,
        put = _ref30.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var backData, ipTableData;
        return _regeneratorRuntime().wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return call(_delete_iptable, payload);
            case 2:
              backData = _context15.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              _context15.next = 6;
              return call(get_iptable_list, {
                company_id: payload.company_id,
                agency_id: payload.agency_id
              });
            case 6:
              ipTableData = _context15.sent;
              _context15.next = 9;
              return put({
                type: "update",
                payload: {
                  ipTableList: ipTableData.result
                }
              });
            case 9:
            case "end":
              return _context15.stop();
          }
        }, _callee15);
      })();
    },
    delete_topo_batch: function delete_topo_batch(_ref31, _ref32) {
      var payload = _ref31.payload;
      var call = _ref32.call,
        put = _ref32.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var backData, topoData;
        return _regeneratorRuntime().wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return call(_delete_topo_batch, payload);
            case 2:
              backData = _context16.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              _context16.next = 6;
              return call(get_topo_list, {
                company_id: payload.company_id
              });
            case 6:
              topoData = _context16.sent;
              _context16.next = 9;
              return put({
                type: "update",
                payload: {
                  topoData: topoData.result
                }
              });
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      })();
    },
    delete_topo: function delete_topo(_ref33, _ref34) {
      var payload = _ref33.payload;
      var call = _ref34.call,
        put = _ref34.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee17() {
        var backData, topoData;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return call(_delete_topo, payload);
            case 2:
              backData = _context17.sent;
              if (backData.success) {
                BossMessage(true, "Successfully deleted");
              } else {
                BossMessage(false, "Delete failed:" + backData.result);
              }
              _context17.next = 6;
              return call(get_topo_list, {
                company_id: payload.company_id
              });
            case 6:
              topoData = _context17.sent;
              _context17.next = 9;
              return put({
                type: "update",
                payload: {
                  topoData: topoData.result
                }
              });
            case 9:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      })();
    },
    create_company_contract: function create_company_contract(_ref35, _ref36) {
      var payload = _ref35.payload;
      var call = _ref36.call,
        put = _ref36.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee18() {
        var backData, contractData;
        return _regeneratorRuntime().wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return call(_create_company_contract, payload);
            case 2:
              backData = _context18.sent;
              if (backData.success) {
                BossMessage(true, "Successfully added");
              } else {
                BossMessage(false, "Add failed:" + backData.result);
              }
              _context18.next = 6;
              return call(get_contract_list, {
                company_id: payload.company_id
              });
            case 6:
              contractData = _context18.sent;
              _context18.next = 9;
              return put({
                type: "update",
                payload: {
                  contractData: contractData.result
                }
              });
            case 9:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      })();
    },
    update_contract: function update_contract(_ref37, _ref38) {
      var payload = _ref37.payload;
      var call = _ref38.call,
        put = _ref38.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee19() {
        var backData, contractData;
        return _regeneratorRuntime().wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return call(_update_contract, payload);
            case 2:
              backData = _context19.sent;
              if (backData.success) {
                BossMessage(true, "Successfully edited");
              } else {
                BossMessage(false, "Editing failed:" + backData.result);
              }
              _context19.next = 6;
              return call(get_contract_list, {
                company_id: payload.company_id
              });
            case 6:
              contractData = _context19.sent;
              _context19.next = 9;
              return put({
                type: "update",
                payload: {
                  contractData: contractData.result
                }
              });
            case 9:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      })();
    },
    create_iptable: function create_iptable(_ref39, _ref40) {
      var payload = _ref39.payload;
      var call = _ref40.call,
        put = _ref40.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee20() {
        var backData, ipTableData;
        return _regeneratorRuntime().wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.next = 2;
              return call(_create_iptable, payload);
            case 2:
              backData = _context20.sent;
              if (!backData.success) {
                _context20.next = 7;
                break;
              }
              BossMessage(true, "Successfully added");
              _context20.next = 9;
              break;
            case 7:
              BossMessage(false, "Add failed:" + backData.result);
              return _context20.abrupt("return", 0);
            case 9:
              _context20.next = 11;
              return call(get_iptable_list, {
                company_id: payload.company_id,
                agency_id: payload.agency_id
              });
            case 11:
              ipTableData = _context20.sent;
              _context20.next = 14;
              return put({
                type: "update",
                payload: {
                  ipTableList: ipTableData.result
                }
              });
            case 14:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      })();
    },
    contractAttachmentInit: function contractAttachmentInit(_ref41, _ref42) {
      var payload = _ref41.payload;
      var put = _ref42.put;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee21() {
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return put({
                type: "update",
                payload: {
                  file_list: payload.file_list
                }
              });
            case 2:
            case "end":
              return _context21.stop();
          }
        }, _callee21);
      })();
    },
    delete_attachment: function delete_attachment(_ref43, _ref44) {
      var payload = _ref43.payload;
      var call = _ref44.call,
        put = _ref44.put,
        select = _ref44.select;
      return /*#__PURE__*/_regeneratorRuntime().mark(function _callee22() {
        var backData, file_list, contractData;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return call(_delete_attachment, payload);
            case 2:
              backData = _context22.sent;
              _context22.next = 5;
              return select(function (state) {
                return state.bi0102Info.file_list;
              });
            case 5:
              file_list = _context22.sent;
              if (!backData.success) {
                _context22.next = 16;
                break;
              }
              file_list = file_list.filter(function (item) {
                return item.filename !== payload.filename;
              });
              _context22.next = 10;
              return call(get_contract_list, {
                company_id: payload.company_id
              });
            case 10:
              contractData = _context22.sent;
              _context22.next = 13;
              return put({
                type: "update",
                payload: {
                  contractData: contractData.result,
                  file_list: file_list
                }
              });
            case 13:
              BossMessage(true, "Successfully deleted");
              _context22.next = 17;
              break;
            case 16:
              BossMessage(false, "Delete failed:" + backData.result);
            case 17:
            case "end":
              return _context22.stop();
          }
        }, _callee22);
      })();
    }
  },
  reducers: {
    update: function update(state, action) {
      return _objectSpread({}, state, action.payload);
    }
  }
};